import { BadgeCheck, Award, GraduationCap } from 'lucide-react';

/** Fixed kind → Lucide icon for Profile Summary pills (never index-based). */
export const PROFILE_BADGE_ICONS = {
  certification: BadgeCheck,
  award: Award,
  education: GraduationCap,
};

export const PROFILE_BADGE_TONE = {
  certification: 'border-amber-200 bg-amber-50 text-amber-900',
  award: 'border-primary/25 bg-primary/10 text-primary',
  education: 'border-slate-200 bg-slate-50 text-slate-800',
};

export function deriveMcqCategoriesFromItems(items) {
  if (!items || !items.length) return [];
  const buckets = new Map();
  for (const it of items) {
    const topic = it.topic || 'General';
    const b = buckets.get(topic) || { name: topic, total: 0, correct: 0, _topics: new Set() };
    b.total += 1;
    if (it.is_correct) b.correct += 1;
    if (it.difficulty) b._topics.add(it.difficulty);
    buckets.set(topic, b);
  }
  return Array.from(buckets.values()).map((b) => ({
    name: b.name, total: b.total, correct: b.correct,
    sample_topics: Array.from(b._topics).slice(0, 3),
  }));
}

export function panelFactorScores(panel) {
  if (Array.isArray(panel.factor_scores) && panel.factor_scores.length) {
    return panel.factor_scores;
  }
  // Client Report shows manual panellist factors only — never AI spider.
  return [];
}

/** True when a panel row has manual ratings and should render in the Client Report. */
export function isPanelReportVisible(panel) {
  if (!panel || panel.feedback_pending) return false;
  return panel.human_overall_score != null
    || (Array.isArray(panel.factor_scores) && panel.factor_scores.length > 0);
}

export function formatDuration(sec) {
  if (sec == null || Number.isNaN(Number(sec))) return '—';
  const s = Math.round(Number(sec));
  if (s < 60) return `${s}s`;
  return `${Math.floor(s / 60)}m ${s % 60}s`;
}

export function finalCallTone(finalCall) {
  if (finalCall === 'strong_recommend' || finalCall === 'recommend') return 'good';
  if (finalCall === 'neutral') return 'neutral';
  if (finalCall === 'not_recommended') return 'bad';
  return 'empty';
}
